import React from "react";
import { NavLink } from "react-router-dom";
import { Routes } from "../../../../app/route/RoutesConfig";
import { useFactoringContext } from "./useFactoringContext";

const FactoringNav: React.FC = () => {
  const { terminalPrefix } = useFactoringContext();
  const links = [
    { label: "Overview", to: Routes.billing.invoiceFactoringOverview, also: Routes.billing.invoiceFactoring },
    { label: "Upload batches", to: Routes.billing.invoiceFactoringBatches },
    { label: "Factored invoices", to: Routes.billing.invoiceFactoringInvoices },
    { label: "Notification settings", to: Routes.billing.invoiceFactoringSettings },
  ];

  return (
    <nav className="xgs-invoice-factoring__nav">
      {links.map((link) => (
        <NavLink
          key={link.to}
          to={`${terminalPrefix}${link.to}`}
          className="xgs-invoice-factoring__nav-link"
          activeClassName="xgs-invoice-factoring__nav-link--active"
          isActive={(_match, location) =>
            location.pathname.includes(link.to) ||
            (!!link.also && location.pathname.replace(/\/$/, "").endsWith(link.also))
          }
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default FactoringNav;
